import styles from './notification_list_item.module.scss';
import {Link} from 'react-router-dom';
import {classNames} from '../../support/classnames.ts';
import {Icon} from '../icon/icon.tsx';
import {daysFromNow} from '../../support/days_from_now.ts';

interface OwnProps {
    title: string;
    message: string;
    date?: string | null;
    to: string;
    read: boolean;
    active?: boolean;
    iconClass?: string;
    src?: string | null;
}
export function NotificationListItem({title, message, date, to, read, active, iconClass, src}: OwnProps) {
    return (
        <Link
            to={to}
            className={classNames(styles.notification_list_item, {
                [styles.active]: active,
                [styles.notification_list_item_read]: read,
            })}
        >
            <div className={styles.item_icon}>
                {src != null ? <Icon src={src} /> : <Icon iconClassName={`fa-light ${iconClass ?? 'fa-user'}`} />}
            </div>

            <div className={styles.item_content}>
                <div className={styles.content_title}>
                    {!read && <i className="fa-solif fa-warning" />}
                    <strong>{title}</strong>
                    <span className={styles.content_title_date}>{date && daysFromNow(date)}</span>
                </div>
                <div className={styles.content_message}>{message}</div>
            </div>
        </Link>
    );
}
